import { ITelemetryItem } from '@microsoft/applicationinsights-web';
import { InjectionToken, ValueProvider } from '@angular/core';

export type AppInsightsTelemtryItem = ITelemetryItem;

/** Can modify telemetry - if this returns false, then no telemtry is sent. */
export type AppInsightsTelemetryInitializer = (telemetry: AppInsightsTelemtryItem) => boolean | void;

/**
 * Optionally PROVIDE telemetry initializers that allow more control over just provided telemetry properties
 */
export const AI_TELEM_INITIALIZERS = new InjectionToken<AppInsightsTelemetryInitializer[]>('AI_TELEM_INITIALIZERS');

/** Creates ValueProvider providing telemtery initializers */
export function provideAiTelemetryInitializers(telemInitializers: AppInsightsTelemetryInitializer[]): ValueProvider {
  return {
    provide: AI_TELEM_INITIALIZERS,
    useValue: telemInitializers
  }
}

/** Add this to AI_TELEM_INITIALIZERS (or provideAiTelemetryInitializers) to prevent http requests with 0 resultCode from being logged. */
export const IGNORE_CANCELED_HTTP_REQUEST_AI_TELEM_INITIALIZER: AppInsightsTelemetryInitializer = (telemetry): boolean => {
  return (telemetry.baseData?.resultCode == null || telemetry.baseData.resultCode !== 0);
}
